import { THeaders } from '../../../types/request';
import {
  IMappers,
  fetchCheckPaymentByProvider,
} from '../../../repositories/billing-payments/v1/check-payment-by-provider';
import { mapResponse200 } from './utils';
import { IGetPaymentStatusDependencies, IPaymentStatus, EPaymentStatus } from './types';

export const getPaymentStatus = async (dependencies: IGetPaymentStatusDependencies): Promise<IPaymentStatus> => {
  const { httpApi, paymentId, provider } = dependencies;

  const parameters = { externalPaymentId: paymentId, paymentProvider: provider };

  const mappers: IMappers<IPaymentStatus> = {
    200: mapResponse200,
  };

  const headers: THeaders = [['Content-Type', 'application/json']];

  const config = {
    requestConfig: {
      headers,
    },
  };

  try {
    const result = await fetchCheckPaymentByProvider<IPaymentStatus>({
      httpApi,
      parameters,
      config,
      mappers,
    });

    return result as IPaymentStatus;
  } catch {
    return { status: EPaymentStatus.Pending, message: null };
  }
};
